<template>
    <div class="upload-file">
      <b-modal
        id="erepInfoRequestForm"
        centered
        size="md"
        hide-footer
        no-close-on-backdrop
        @shown="fetchAddressForPolicy"
      >
        <template #modal-header>
          <div class="repInfoRequestForm-header  text-center">
            <!--<h4>{{ !row ? "Add" : "" }} Information Request</h4>-->
  
            <b-button
              variant="close-btn"
              class="btn-container"
              @click="closeModal"
            >
              <i class="fas fa-times"></i>
            </b-button>
          </div>
        </template>
        <b-container fluid>
          <div class="repInfoRequestForm-form">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form
                @submit.stop.prevent="handleSubmit(createRequest)"
                ref="repInfoRequestContainer"
              >

                <input-text
                  labelFor="type"
                  labelName="Type"
                  inputName="type"
                  formGroupClass="form-group mb-3"
                  :vmodel="typeDisplay"
                  readonly
                />
                <input-text
                  labelFor="member_policy"
                  labelName="Member - Policy"
                  inputName="member_policy"
                  formGroupClass="form-group mb-3"
                  :vmodel="memberPolicy"
                  readonly
                />
                <input-multi-select
                  :vmodel.sync="form.full_address"
                  labelName="Full Address"
                  :options="address.map((type) => type.formatted_name)"
                  :custom-label="
                  (opt) =>address.find((x) => x.formatted_name == opt).formatted_name
                  "
                  :rules="{ required: true }"
                  formGroupClass="form-group mb-3"
                  placeholder="Select Full Address"
                  :is-loading="addressLoading"
                />
                <input-multi-select
                  :vmodel.sync="form.cards_requested"
                  labelName="Number of Cards Requested"
                  :options="requestOptions.map((type) => type.number)"
                  :custom-label="
                    (opt) => requestOptions.find((x) => x.value == opt).number
                  "
                  :rules="{ required: true }"
                  formGroupClass="form-group mb-3"
                  placeholder="Select Number of Card"
                />
  
                <!--<input-file
                  :rules="{ required: false }"
                  labelFor="document"
                  labelName="Select Document "
                  inputName="document"
                  :vmodel.sync="form.document"
                  :apiErrors="apiErrors"
                  formGroupClass="form-group mb-3"
                  fieldName="document"
                />-->

                <input-textarea
                  labelFor="information"
                  labelName="Information"
                  inputName="information"
                  :vmodel.sync="form.information"
                  formGroupClass="form-group mb-3"
                />
  
                <div class="col-md-12">
                  <b-button
                    class="univ-btnEdit"
                    type="submit"
                    :disabled="isCreate"
                  >
                    <template>
                      {{ isCreate ? "Sending Request ..." : "Send Request" }}
                    </template>
                  </b-button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </b-container>
      </b-modal>
    </div>
  </template>
  <script>
  import Api from "@/resource/Api";
  const formData = {
    type: "member_card",
    information: "",
    policy_id: "",
    document: "",
    cards_requested: "",
    full_address: "",
  };
  export default {
    name: "erepInfoRequestForm",
    props: {
      row: {
        default: null,
      },
    },
    data() {
      return {
        form: { ...formData },
        isCreate: false,
        isLoading: false,
        types: [],
        members: [],
        address: [],
        apiErrors: null,
        requestOptions: [
          {
            number: "1",
            value: 1,
          },
          {
            number: "2",
            value: 2,
          },
          {
            number: "3",
            value: 3,
          },
          {
            number: "4",
            value: 4,
          },
          {
            number: "5",
            value: 5,
          },
        ],
      };
    },
    methods: {
      fetchAddressForPolicy() {
      if (!this.row || !this.row.policy_id) {
        this.address = [];
        return;
      }

      this.addressLoading = true;

      const tempForm = new FormData();
      tempForm.append("policy_id", this.row.policy_id);

      Api.post("v2/rep-info-request/get-address", tempForm)
        .then((response) => {
          const addressList = response.data?.data?.address_list || [];

          if (addressList.length > 0) {
            this.address = addressList.map((item) => ({
              policy_id: this.row.policy_id,
              formatted_name: item.full_address,
            }));
            this.form.full_address = "";
          } else {
            this.address = [
              {
                policy_id: this.row.policy_id,
                formatted_name: "No address found for this policy",
              },
            ];
            this.form.full_address = "";
          }
        })
        .catch((error) => {
          console.error("Error fetching address:", error);
          this.address = [
            {
              policy_id: this.row.policy_id,
              formatted_name: "Unable to fetch address for this policy",
            },
          ];
          this.form.full_address = "";
        })
        .finally(() => {
          this.addressLoading = false;
        });
    },
      reset() {
        this.form = { ...formData };
      },
      closeModal() {
        this.$emit("update:row", null);
        this.$bvModal.hide("erepInfoRequestForm");
        this.reset();
      },
      async createRequest() {
        let url;
        this.isCreate = true;
        url = "v2/rep-info-request/enrollprime/store";
        let loader = this.$loading.show({
          container: this.$refs.createRequestContainer,
        });
        let formData = new FormData();
        this.form.policy_id = this.row.policy_id;
        for (const [key, value] of Object.entries(this.form)) {
          formData.append(key, value);
        }
        await Api.post(url, formData)
          .then((res) => {
            this.$notify(res.data.message);
            this.closeModal();
            this.$emit("onSuccess");
          })
          .catch((error) => {
            if (error.response.status == 422) {
              this.apiErrors = error.response.data.errors;
              // setTimeout(() => {
              //   this.apiErrors = null;
              // }, 5000);
            } else {
              this.$notify(error.response.data.message, "error");
            }
          })
          .finally(() => {
            this.isCreate = false;
            setTimeout(() => {
              loader.hide();
            }, 2000);
          });
      },
    },
    computed: {
      memberPolicy() {
        return this.row? this.row.first_name + " " + this.row.last_name + " - " + this.row.policy_id: "";
      },
      typeDisplay() {
        return "Member Card";
      },
    },
  };
  </script>
  
  <style>
  .repInfoRequestForm-header h4 {
    font-size: 20px;
    color: #2c3f58;
    font-weight: 600;
  }
  .repInfoRequestForm-header p {
    font-size: 14px;
    color: #2c3f58;
  }
  .repInfoRequestForm-header button {
    position: absolute;
    top: -15px;
    right: -15px;
    background: #fff;
    color: #000;
    border: 0;
    box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
    border-radius: 60px;
    font-size: 18px;
    width: 45px;
    height: 45px;
    align-items: center;
    justify-content: center;
    display: flex;
  }
  .repInfoRequestForm-form label {
    display: block;
    color: #5e5e5e;
    font-size: 14px;
    margin-bottom: 8px;
    font-weight: 500;
  }
  
  .repInfoRequestForm-header .btn-container {
    position: absolute;
    top: -14px !important;
    right: -15px;
    background: #fff;
    color: #000;
    border: 0;
    box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
    border-radius: 60px;
    font-size: 18px;
    width: 45px;
    height: 45px;
    align-items: center;
    justify-content: center;
    display: flex;
  }
  .repInfoRequestForm-form .multiselect{
    width: 100% !important;
    margin-left: 0 !important;
}
  </style>
  